export default __webpack_public_path__ + "static/image1-bd79ae0db4ab9fc758a0351d6e619f99.jpeg";